/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withResizeHandle = _interopRequireDefault(require("../hocs/withResizeHandle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * A renderProp component for providing container size
 * input to child components.
 * Using withResizeHandle to measure the dimensions
 * of the container, passing the width and height
 * down to its children.
 *
 * @returns {SizeHandler} The SizeHandler component.
 */
var SizeHandler = (0, _withResizeHandle["default"])(function (_ref) {
  var containerDimensions = _ref.containerDimensions,
    maxWidth = _ref.maxWidth,
    maxHeight = _ref.maxHeight,
    children = _ref.children;
  var width = containerDimensions.width,
    height = containerDimensions.height;
  return children({
    width: (maxWidth ? Math.min(width, maxWidth) : width) || 0,
    height: (maxHeight ? Math.min(height, maxHeight) : height) || 0
  });
});
SizeHandler.propTypes = {
  /**
   * The child components
   */
  children: _propTypes["default"].any,
  /**
   * These dimensions will be provided
   * by withResizeHandler.
   */
  containerDimensions: _propTypes["default"].shape({
    height: _propTypes["default"].number,
    width: _propTypes["default"].number
  }),
  /**
   * The max height to pass down to its children.
   */
  maxHeight: _propTypes["default"].number,
  /**
   * The max width to pass down to its children.
   */
  maxWidth: _propTypes["default"].number
};
var _default = SizeHandler;
exports["default"] = _default;